import React, { ReactNode } from "react";
import { Box } from "@chakra-ui/react";
import { colors, responsive } from "goi_common";

export default function GuideBox({ children }: { children: ReactNode }) {
  return (
    <Box
      className="body_16_m lg_subtitle_16_b gray800"
      css={responsive({
        margin: { base: "0 24px", lg: "0" },
        padding: { base: "20px", lg: "18px 32px" },
        background: colors.warmGray150,
        borderRadius: "10px",
      })}
    >
      {children}
    </Box>
  );
}
